import React from "react";
import axios from "axios";
import Select from "react-select";
import Spinner from "../../components/Spinner";
import { Modal } from "../../components/Modal";

const API = localStorage.getItem("assethost");

export default class Allocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      valid: true,
      msg: "",
      toastColor: "",
      assetId: "",
      assetType: "",
      assetBrand: "",
      assetModel: "",
      assetUniqueIdentier: "",
      flagId: "",
      flag: {},

      // Allocation form fields
      caseReferenceNumber: "",
      lawEnforcementProfileId: "",
      flagType: "",
      houseBuildingNoStreet: "",
      surburb: "",
      townCityName: "",
      country: "",
      officialReport: "",
      policeReportName: "",
      policeReportId: "",
      policeReportFile: null,

      // Dropdown data
      assetFlagDropdownList: {},
      lawEnforcements: [],
      assetStatuss: [],

      errors: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleAllocate = this.handleAllocate.bind(this);
    this.fetchDropdownLists = this.fetchDropdownLists.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    let assetId = urlParams.get("assetId");
    if (!assetId) {
      assetId = this.props.assetId;
    }
    let flag = this.props.flag;
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    if (assetId) {
      axios
        .get(API + "/asset/getassetflagbyid/" + flag.flagId, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const data = response.data || {};
          flag.flagDate = data.flagDate;
          flag.country = data.country;
          flag.townCityName = data.townCityName;
          flag.houseBuildingNoStreet = data.houseBuildingNoStreet;
          flag.surbub = data.surbub;
          flag.assetStatuss = data.assetStatuss;
          flag.lawEnforcements = data.lawEnforcements;
          this.setState(
            {
              assetId,
              flag,
            },
           
          );
        })
        .catch((error) => {
          // Don't show error for dropdown loading failure, just continue
          console.log("Failed to load dropdowns:", error);
        });
    } else {
      this.setState({
        msg: "No asset ID or flag ID provided",
        toastColor: "danger",
      });
    }
  }

  fetchDropdownLists() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true });
    axios
      .get(API + `/asset/getassetflaggedsearchdropdownlist`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        this.setState({
          assetFlagDropdownList: response.data,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg:
            error?.response?.data?.message || "Failed to load dropdown lists.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  handleSelect(name, value) {
    this.setState({ [name]: value }, this.validate);
  }

  handleFileChange(e) {
    const { name } = e.target;
    const file = e.target.files ? e.target.files[0] : null;
    this.setState({ [name]: file }, this.validate);
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (
      !s.lawEnforcementProfileId ||
     // !s.lawEnforcementProfileId.trim() ||
      !Number(s.lawEnforcementProfileId)
    ) {
      errors.lawEnforcementProfileId = "Law enforcement is required";
      valid = false;
    }
    if (!s.caseReferenceNumber || !s.caseReferenceNumber.trim()) {
      errors.caseReferenceNumber = "Case Reference Number is required";
      valid = false;
    }
    if (!s.flagType || !s.flagType.trim()) {
      errors.flagType = "Flag type is required";
      valid = false;
    }

    this.setState({ errors, valid });
    return valid;
  }

  handleAllocate(e) {
    e.preventDefault();
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    let request = {
      assetId: this.state.assetId,
      flagId: this.state.flag.flagId,
      lawEnforcementProfileId: this.state.lawEnforcementProfileId,
      assetStatus: this.state.flagType,
      caseReferenceNumber: this.state.caseReferenceNumber
    };

    axios
      .post(API + "/asset/flaggedassetallocation", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            msg: response.data.message || "Asset allocated successfully!",
            toastColor: "success",
            loading: false,
          });
          setTimeout(() => {
            this.props.closeAction();
            if (this.props.onSuccess) {
              this.props.onSuccess();
            }
          }, 2000);
        } else {
          this.setState({
            msg: response.data.message || "Allocation failed",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Allocation failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return (
        <Modal title="Asset Allocation" footerContent={<></>}>
          <div className="w-100 h-10 overflow-hidden d-flex justify-content-center align-items-center">
            <Spinner className="" />
          </div>
        </Modal>
      );
    }

    return (
      <Modal
        title="Asset Allocation"
        closeAction={this.props.closeAction}
        footerContent={
          <>
            {s.valid && s.lawEnforcementProfileId && (
              <button
                type="button"
                className="btn btn-primary disabled:cursor-not-allowed"
                disabled={!s.valid}
                onClick={this.handleAllocate}
              >
                Allocate
              </button>
            )}
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.props.closeAction}
            >
              Close
            </button>
          </>
        }
      >
        {divMsg}
        <div className="row">
          <div className="col">
            <b>Type: </b>
            <span>{s.flag?.subcategoryName}</span>
          </div>
          <div className="col">
            <b>Unique Identifier: </b>
            <span>{s.flag?.uniqueIdentifier}</span>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <b>Flag Type: </b>
            <span>{s.flag?.secondaryStatus}</span>
          </div>
          <div className="col">
            <b>Date: </b>
            <span>{s.flag?.flagDate}</span>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <b>House / Building No: </b>
            {s.flag?.houseBuildingNoStreet}
          </div>
        </div>
        <div className="row">
          <div className="col">
            <b>Town / City: </b>
            {s.flag?.townCityName}
          </div>
          <div className="col">
            <b>Country: </b>
            {s.flag?.country}
          </div>
        </div>
        <div className="row">
          <div className="col">
            <b>Have you made an official police report?: </b>
            {s.flag?.officialReport}
          </div>
        </div>
        <div className="row">
          <div className="col">{s.flag?.fileName}</div>
        </div>
        <form
          className="d-flex flex-column w-100 mt-2"
          autoComplete="off"
          onSubmit={this.handleAllocate}
        >
            <div className="row">
            <div className="col">
              <div className="input-group">
                <label className="input-group-text !w-80">
                  Case Reference Number
                </label>
                <input
                type="text"
                  name="caseReferenceNumber"
                  value={s.flag?.caseReferenceNumber }
                  onChange={this.handleChange}
                  className={`form-control ${
                    s.errors.caseReferenceNumber ? " !border-red-500" : ""
                  }`}
                  required
                />
                {s.errors.caseReferenceNumber && (
                  <span className="input-group-error">
                    {s.errors.caseReferenceNumber}
                  </span>
                )}
              </div>
            </div>
            <div className="col"></div>
            </div>
          <div className="row">
            <div className="col">
              <div className="input-group">
                <label className="input-group-text !w-80">
                  Law Enforcement
                </label>
                <Select
                  name="lawEnforcementProfileId"
                  value={(
                    s.flag?.lawEnforcements || []
                  ).filter(({ value }) => value === s.lawEnforcementProfileId)}
                  onChange={(e) =>
                    this.handleSelect(
                      "lawEnforcementProfileId",
                      e ? e.value : ""
                    )
                  }
                  className={`form-control ${
                    s.errors.lawEnforcementProfileId ? " !border-red-500" : ""
                  }`}
                  required
                  options={s.flag?.lawEnforcements || []}
                />
                {s.errors.lawEnforcementProfileId && (
                  <span className="input-group-error">
                    {s.errors.lawEnforcementProfileId}
                  </span>
                )}
              </div>
            </div>
            <div className="col">
              <div className="input-group">
                <label className="input-group-text">Flag Type</label>
                <select
                  name="flagType"
                  className={`form-control ${
                    s.errors.flagType ? " !border-red-500" : ""
                  }`}
                  value={s.flagType}
                  onChange={this.handleChange}
                  required
                >
                  <option value="">Select</option>
                  {s.flag?.assetStatuss?.map((status) => (
                    <option key={`flag-type-${status}`} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
                {s.errors.flagType && (
                  <span className="input-group-error">{s.errors.flagType}</span>
                )}
              </div>
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}
